import React from 'react';
import { Link as RouterLink } from 'react-router';
import Radium from 'radium';

const DEFAULT_WIDTH = 171;
const DEFAULT_HEIGHT = 45;

const Link = Radium(RouterLink);

export default class Logo extends React.Component {
  static propTypes = {
    width: React.PropTypes.number,
  };

  render() {
    let width = this.props.width || 171;
    let height = 45 * width / 171;
    if (this.props.width) {
      width = this.props.width;
      height = DEFAULT_HEIGHT * width / DEFAULT_WIDTH;
    } else if (this.props.height) {
      height = this.props.height;
      width = DEFAULT_WIDTH * height / DEFAULT_HEIGHT;
    }
    return (
      <Link
        to="/"
        style={{
          textDecoration: 'none',
          backgroundImage: this.props.dark ?
            'url(/logo-dark.svg)' :
            'url(/logo.svg)',
          backgroundSize: `${width}px ${height}px`,
          width,
          height,
          display: 'block',
          textIndent: -9999,
          overflow: 'hidden',
          '@media (max-width: 700px)': {
            width: width > 100 ? height : width,
          },
        }}>
        Reindex
      </Link>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./ui/_Logo.jsx
 **/